import { api } from 'api'
import { useMutation } from '@tanstack/react-query'
import { toaster } from 'uikit/Toaster'

export const useSaveProvidersSettings = () => {
  return useMutation({
    mutationFn: (data: any) => api.providers.saveSmsProviders(data),
    onSuccess: () => {
      toaster.create({
        type: 'success',
        title: 'Данные успешно обновлены',
      })
    },
    onError: (err: any) => {
      toaster.create({
        type: 'error',
        title: 'Произошла ошибка при сохранении конфигурации провайдеров',
        description: err.response?.data?.message || err.message,
      })
    },
  })
}
